// extracted by mini-css-extract-plugin
export default {"label":"Footer_label__ZmX3n"};